import axios from 'axios';

import { FORCE_LOGOUT_AUTH_ERRORS } from './forceLogoutAuthErrors';

type ApiErrorResponseBody = {
    message?: unknown;
};

const getApiErrorMessage = (data: unknown): string | undefined => {
    if (typeof data !== 'object' || data === null || !('message' in data)) {
        return undefined;
    }

    const message = (data as ApiErrorResponseBody).message;
    return typeof message === 'string' ? message : undefined;
};

export const isForceLogoutAuthError = (error: unknown): boolean => {
    if (!axios.isAxiosError(error)) {
        return false;
    }

    const status = error.response?.status;
    const message = getApiErrorMessage(error.response?.data);

    if (status === undefined || message === undefined) {
        return false;
    }

    return FORCE_LOGOUT_AUTH_ERRORS.some((rule) => rule.status === status && rule.message === message);
};
